/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2020 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { takeLatest, put, select } from 'redux-saga/effects';
import { UPDATE_VIEW_PLUGIN_CONFIG, TOGGLE_USER_USES_ORG } from '../actions';
import { manageViewPluginsMode } from '../data/prefabs';
import {
  writeViewPluginToOrg,
  writeViewPluginToUser
} from '../../common/actions';
import {
  selectOrgViewPlugins
} from '../../common/selectors';

export function* doUpdatePluginConfig({ payload }) {
  const mode = yield select(manageViewPluginsMode.value);
  const action = mode === 'org' ? writeViewPluginToOrg : writeViewPluginToUser;
  yield put(action(payload));
}

export function* doToggleUserUsesOrg({ payload: useOrg }) {
  let data = [];
  if (!useOrg) {
    data = yield select(selectOrgViewPlugins);
  }
  yield put(writeViewPluginToUser(data));
}

export function* watchUpdatePluginConfig() {
  yield takeLatest(UPDATE_VIEW_PLUGIN_CONFIG, doUpdatePluginConfig);
}

export function* watchToggleUserUsesOrg() {
  yield takeLatest(TOGGLE_USER_USES_ORG, doToggleUserUsesOrg);
}
